import AutoDeliveryDcxOnHoldInfoBox from '@/views/AutoDeliveryDcx/AutoDeliveryDcxOnHold/AutoDeliveryDcxOnHoldInfoBox';

import AutoDeliveryDcxDetailsMobile from '../components/AutoDeliveryDcxDetailsMobile';
import useAutoDeliveryDcxDetails from '../hooks/useAutoDeliveryDcxDetails';

const StatusOnHoldMobile = () => {
    const {
        autoDelivery: {statusUpdateReason},
    } = useAutoDeliveryDcxDetails();

    return (
        <AutoDeliveryDcxDetailsMobile
            status='onHold'
            orderDetailsExtraSection={
                <AutoDeliveryDcxOnHoldInfoBox className='mt-4' statusUpdateReason={statusUpdateReason} />
            }
        />
    );
};

export default StatusOnHoldMobile;
